function getItemNameByCode (items, code, type) {
  if (code === '*') {
    return `All ${type}`;
  }

  const itemFound = (items || []).find(item => item.code === code);

  return itemFound ? itemFound.name : 'N/A';
}

function isPositiveInteger (val) {
  if (!Number.isInteger(parseFloat(val)) || parseFloat(val) <= 0) {
    return 'Invalid Number';
  }

  return true;
}

// Formats a date time to a string like: 02/06/2019 à 06:54:32
function formatDateTime (dateTime) {
  return new Date(dateTime).toLocaleString('fr-FR');
}

const findContentTypeFromFilter = state => {
  const wtypeSelected = state.search.filters.find(f => f.field === 'wtype');
  if (!wtypeSelected) {
    return null;
  }

  const foundContentType = Object.values(state.rawContentTypes).find(ct => ct.configs && ct.configs.wtype === wtypeSelected.value);

  if (!foundContentType) {
    return null;
  }

  return {
    wtype: wtypeSelected,
    ...foundContentType
  };
};

const sortSelect = (array, sort, field) => {
  array.sort((a, b) => (eval(`"${a[field]}" ${!sort.toString().toLowerCase().includes('desc') ? '>' : '<'} "${b[field]}"`) ? 1 : -1));

  return array;
};

const normalizeUrl = path => {
  // Collapse consecutive slashes: /example1//example2 -> /example1/example2
  const normalizedPath = path.replace(/\/{2,}/g, '/');

  // Strip trailing slash: /example/ -> /example (but keep root "/")
  return normalizedPath.length > 1 && normalizedPath.endsWith('/') ? normalizedPath.slice(0, -1) : normalizedPath;
};

export {
  findContentTypeFromFilter,
  getItemNameByCode,
  isPositiveInteger,
  formatDateTime,
  sortSelect,
  normalizeUrl
};
